<template>
  <Portal selector="#uiToastManager">
    <transition-group
      tag="div"
      :class="[
        'UIElement',
        $style.ToastManager
      ]"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
    >
      <div
        v-for="(item, index) in items"
        :key="item.id"
        :class="$style.Toast"
        :data-index="index"
        :style="{
          transform: getItemTransform(index)
        }"
      >
        {{item.title}}
        <Icon
          :class="$style.Toast_icon"
          icon="fal fa-times"
          @click="removeItem(item)"
        />
      </div>
    </transition-group>
  </Portal>
</template>

<script>
import {Portal} from '@linusborg/vue-simple-portal'
import {Icon} from '../Icon'

const itemX = 'calc(-100% - 20px)'

export default {
  components: {
    Icon,
    Portal
  },
  data() {
    return {
      nextId: 0,
      items: []
    }
  },
  methods: {
    addItem(data) {
      const item = {
        ...data,
        id: this.nextId++
      }
      this.items.push(item)
      setTimeout(() => {
        this.removeItem(item)
      }, item.duration || 4500)
    },
    removeItem(item) {
      const index = this.items.indexOf(item)
      if (index >= 0) {
        this.items.splice(index, 1)
      }
    },
    beforeEnter(el) {
      el.style.opacity = 0
      el.style.transform = `translate(${itemX}, 100px)`
    },
    enter(el, done) {
      setTimeout(() => {
        const index = parseInt(el.dataset.index, 10)
        el.style.opacity = 1
        el.style.transform = this.getItemTransform(index)
      }, 0)
      setTimeout(done, 300)
    },
    leave(el, done) {
      el.style.opacity = 0
      setTimeout(done, 500)
    },
    getItemTransform(index) {
      // Reverse index
      const i = this.items.length - index - 1
      const baseOffset = 65 + ((i + 1) * 16)
      const calcY = `calc(-${i * 100}% - ${baseOffset}px)`
      return `translate(${itemX}, ${calcY})`
    }
  }
}
</script>

<style lang="scss" module>
.ToastManager {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1100;
}

.Toast {
  position: absolute;
  display: flex;
  align-items: center;
  padding: 16px;
  background: #202121;
  border-radius: 3px;
  color: #fff;
  font-size: 20px;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 1s, transform .5s;
}

.Toast_icon {
  margin-left: 20px;
  font-size: 30px;
  cursor: pointer;
}
</style>
